import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface ISettingsStoreAddition {
  settings: ISettingsSliceState
}

interface ISettingsSliceState {
  settings?: ISettingsDto
  isLoading?: boolean
  adminShowRegistrations?: boolean
}

const initialState: ISettingsSliceState = {
  isLoading: true,
}

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<ISettingsDto>) => {
      state.settings = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setAdminShowRegistrations: (state, action: PayloadAction<boolean>) => {
      state.adminShowRegistrations = action.payload
    },
  },
})

export const settingsActions = settingsSlice.actions
export const settingsSelectors = {
  settings: (state: ISettingsStoreAddition) => state.settings.settings,
  isLoading: (state: ISettingsStoreAddition) => state.settings.isLoading,
  adminShowRegistrations: (state: ISettingsStoreAddition) => state.settings.adminShowRegistrations,
}
